import { useState } from "react";
import { api, getUser, taskTypeLabel } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Landmark, CheckCircle2, XCircle, Clock } from "lucide-react";

const TRANSFER_ROLES = ["admin", "manager", "employee", "buchhaltung"];

export function TaskTypeBadge({ typ, testid }) {
  if (typ === "ueberweisung_rueckfrage") {
    return <Badge className="bg-amber-100 text-amber-900 border-amber-200 gap-1" data-testid={testid}><Landmark className="w-3 h-3" /> {taskTypeLabel(typ)}</Badge>;
  }
  return <Badge variant="outline" data-testid={testid}>{taskTypeLabel(typ)}</Badge>;
}

// Rückfrage „Ist die Überweisung eingegangen?“ direkt aus der Aufgabenliste beantworten (gleiche Endpunkte wie im Auftrag).
export function TransferTaskActions({ task, onDone }) {
  const [busy, setBusy] = useState(false);
  if (task.typ !== "ueberweisung_rueckfrage" || !task.related_order_id || ["erledigt", "abgebrochen"].includes(task.status)) return null;
  if (!TRANSFER_ROLES.includes(getUser()?.rolle)) return null;
  const act = async (aktion, msg) => {
    if (aktion === "stornieren" && !window.confirm("Überweisung nicht eingegangen – Auftrag wirklich stornieren?")) return;
    setBusy(true);
    try { await api.post(`/auftraege/${task.related_order_id}/ueberweisung/${aktion}`); toast.success(msg); onDone(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Aktion fehlgeschlagen."); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap gap-1 mt-2" data-testid={`task-transfer-actions-${task.task_nummer}`}>
      <Button size="sm" variant="outline" className="h-7 text-xs text-emerald-700" disabled={busy} onClick={() => act("eingegangen", "Zahlung als eingegangen markiert.")} data-testid={`task-transfer-paid-${task.task_nummer}`}>
        <CheckCircle2 className="w-3.5 h-3.5 mr-1" /> Zahlung eingegangen
      </Button>
      <Button size="sm" variant="outline" className="h-7 text-xs text-rose-700" disabled={busy} onClick={() => act("stornieren", "Auftrag storniert.")} data-testid={`task-transfer-cancel-${task.task_nummer}`}>
        <XCircle className="w-3.5 h-3.5 mr-1" /> Nicht eingegangen – stornieren
      </Button>
      <Button size="sm" variant="ghost" className="h-7 text-xs" disabled={busy} onClick={() => act("morgen", "Rückfrage kommt morgen erneut.")} data-testid={`task-transfer-tomorrow-${task.task_nummer}`}>
        <Clock className="w-3.5 h-3.5 mr-1" /> Morgen erneut fragen
      </Button>
    </div>
  );
}
